import {
  ref, onMounted, onBeforeMount, onBeforeUnmount,
} from 'vue';
import { mediaQuery } from '../../scripts/lib/mediaQuery';

const templateElement = document.getElementById('sticky-vsp-bar-template');

export default {
  template: templateElement ? templateElement.innerHTML : '',

  props: {
    syan: {
      type: Number,
      required: true,
    },
    colorId: {
      type: String,
      required: false,
    },
    isShownEarly: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const stickyVspBar = ref(null);
    const isMobileViewport = ref(mediaQuery.up_to_L);
    const visible = ref(false);
    const observationDebounceTimeout = ref(null);
    const mobileObserver = ref(null);
    const desktopObserver = ref(null);

    onMounted(() => {
      setupObservers();
    });

    onBeforeMount(() => {
      mediaQuery.on('change:width', () => {
        isMobileViewport.value = mediaQuery.up_to_L;
        setupObservers();
      });
      document.addEventListener('bewe:ents:variantenwechsel', setupObservers);
    });

    onBeforeUnmount(() => {
      clearTimeout(observationDebounceTimeout.value);
      document.removeEventListener('bewe:ents:variantenwechsel', setupObservers);
      stopDesktopObserver();
      stopMobileObserver();
    });

    function getPayload() {
      return {
        syan: props.syan,
        ...(props.colorId ? { farbId: props.colorId } : {}),
        listName: 'pds_sticky',
      };
    }

    function openVsp() {
      const payload = getPayload();
      document.dispatchEvent(new CustomEvent('suchen:vsp:alternativeprodukte', { detail: payload }));
      console.info('Visuell ähnliche Produkte werden angezeigt:', payload);
      stickyVspBar.value.setAttribute('data-test-ents-vsp-bar-payload-emitted', JSON.stringify(payload));
    }

    function setupMobileObserver() {
      if (isMobileViewport.value && !visible.value) {
        stopMobileObserver();
        clearTimeout(observationDebounceTimeout.value);
        mobileObserver.value = new IntersectionObserver((entries) => {
          observationDebounceTimeout.value = setTimeout(() => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && isMobileViewport.value && !visible.value) {
                handleObservation();
              }
            });
          }, 150); // needed because mediaQuery changes are debounced by 100ms
        }, { threshold: 0.0, rootMargin: '10000px 0px 0px 0px' });

        mobileObserver.value.observe(stickyVspBar.value);
      }
    }

    function setupDesktopObserver() {
      if (!isMobileViewport.value && !visible.value) {
        stopDesktopObserver();
        clearTimeout(observationDebounceTimeout.value);
        const desktopImages = document.querySelectorAll('.ents-bilder-ansicht__desktop .ents-bilder-ansicht__entry');
        let targetImage;
        let thresholdValue;

        if (props.isShownEarly) {
          targetImage = desktopImages[0];
          thresholdValue = 0.8;
        } else {
          targetImage = desktopImages[1];
          thresholdValue = 0.5;
        }

        if (targetImage) {
          desktopObserver.value = new IntersectionObserver((entries) => {
            observationDebounceTimeout.value = setTimeout(() => {
              entries.forEach((entry) => {
                if (entry.isIntersecting && !isMobileViewport.value && !visible.value) {
                  handleObservation();
                }
              });
            }, 150); // needed because mediaQuery changes are debounced by 100ms
          }, { threshold: thresholdValue, rootMargin: '10000px 0px 0px 0px' });

          desktopObserver.value.observe(targetImage);
        }
      }
    }

    function setupObservers() {
      setupMobileObserver();
      setupDesktopObserver();
    }

    function handleObservation() {
      visible.value = true;
      stopDesktopObserver();
      stopMobileObserver();
    }

    function stopDesktopObserver() {
      if (desktopObserver.value) {
        desktopObserver.value.disconnect();
      }
    }

    function stopMobileObserver() {
      if (mobileObserver.value) {
        mobileObserver.value.disconnect();
      }
    }

    return {
      stickyVspBar,
      openVsp,
      visible,
      isMobileViewport,
    };
  },
};
